export class Location {
   longitude: number;
   lattitude: number;

}